import { ProductCodeRange } from "./LeadProducts";

export class Preferences {
  PersonId: number;
  SilPromotionalEmailsConsent: boolean;
  SilInvestmentMonitoringEmailsConsent: boolean;
  SilMarketingConsent: boolean;
  PartnerConsent: boolean;
}
export class PersonAndPreferences {
  SilPromotionalEmailsConsent: boolean;
  SilInvestmentMonitoringEmailsConsent: boolean;
  SilMarketingConsent: boolean;
  PartnerConsent: boolean;
}

export class IsSubscriptionAllowedReqObj {
  Uci: string;
  ProductRangeCd: ProductCodeRange;
}

export class IsSubscriptionAllowedResponse {
  Uci: string;
  IneligibilityReason: EligibilityReason;
}

export enum EligibilityReason {
  InvalidAge = 0,
  NotBelgianResident = 1,
  NissExpiryMissing = 2,
  NissExpired = 3
}

export enum CZFlow {
  ResumeSimulation = 1,
  CreateYongoSimulation = 2,
  StartNewInvestment = 3
}


